module.exports = __webpack_public_path__ + "img/img-7.8cece49f.jpg";